import {
  base64UrlToUint8Array,
  arrayBufferToBase64Url,
} from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/services/webauthn';
import type { AssertionOptions } from '../types';

export { getWebAuthnErrorMessage } from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/services/webauthn';

export interface AssertionResponse {
  readonly credentialId: string;
  readonly rawCredentialId: string;
  readonly credentialType: string;
  readonly response: {
    readonly clientDataJSON: string;
    readonly authenticatorData: string;
    readonly signature: string;
    readonly userHandle: string;
  };
}

export function buildAssertionOptions(
  assertionOptions: AssertionOptions
): PublicKeyCredentialRequestOptions {
  return {
    challenge: base64UrlToUint8Array(assertionOptions.challenge),
    rpId: assertionOptions.rpId || 'ebanx.com',
    timeout: assertionOptions.timeout ?? 60000,
    userVerification: assertionOptions.userVerification || 'preferred',
  };
}

export function extractAssertionResponse(credential: PublicKeyCredential): AssertionResponse {
  const assertionResponse = credential.response as AuthenticatorAssertionResponse;

  return {
    credentialId: credential.id,
    rawCredentialId: arrayBufferToBase64Url(credential.rawId),
    credentialType: credential.type,
    response: {
      clientDataJSON: arrayBufferToBase64Url(assertionResponse.clientDataJSON),
      authenticatorData: arrayBufferToBase64Url(assertionResponse.authenticatorData),
      signature: arrayBufferToBase64Url(assertionResponse.signature),
      userHandle: assertionResponse.userHandle ? arrayBufferToBase64Url(assertionResponse.userHandle) : '',
    },
  };
}
